interface SearchIntentParams {
  q?: string;
  category?: string;
  lat?: number;
  lng?: number;
  location?: string;
  sort?: string;
  when_date?: string;
  when_time?: string;
}

function buildSearchIntent(params: SearchIntentParams): string {
  return [
    params.q ?? "",
    params.category ?? "",
    params.lat ?? "",
    params.lng ?? "",
    params.location ?? "",
    params.sort ?? "",
    params.when_date ?? "",
    params.when_time ?? "",
  ].join("\0");
}

export { buildSearchIntent };
